import { StorageObject } from '@etp/etp-storage-client/axios';
import moment from 'moment';
import { decodeTime } from 'ulid';
import { Ulid } from 'id128';

const uuidRegex =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export function formatFolders(input: StorageObject[]): StorageObject[] {
  input.forEach((folder: StorageObject) => {
    if (!folder.createdAt) {
      try {
        const convertedDate = convertUuid(folder.actualName);
        if (convertedDate) {
          folder.createdAt = validateDate(convertedDate);
        } else {
          folder.createdAt = '';
        }
      } catch {
        folder.createdAt = '';
      }
    }
  });
  return input;
}

function convertUuid(id: string): Date | null {
  if (uuidRegex.test(id)) {
    return new Date(
      decodeTime(Ulid.fromRaw(id.split('-').slice(2).join('')).toCanonical())
    );
  }
  return null;
}

function validateDate(date: Date): string {
  const momentDate = moment(date);
  return momentDate.isValid() && momentDate.isBefore(moment())
    ? momentDate.format()
    : '';
}
